import { Component } from 'react';

class ChatRoom extends Component {
  render() {
    return <div>ChatRoom</div>;
  }
}

export default ChatRoom;
